











































import { Note } from "../models/Note";
import NoteEdit from "./NoteModalPartials/NoteEdit.vue";
import NoteListButton from "./NoteModalPartials/NoteListButton.vue";
import NotesList from "./NoteModalPartials/NotesList.vue";

export default {
    name: "NoteModal",
    components: { NotesList, NoteListButton, NoteEdit },
    props: {
        showModal: Boolean,
        showListDefault: Boolean,
    },
    data() {
        return {
            note: new Note({}),
            showList: false,
        };
    },
    methods: {
        closeDialog: function () {
            this.$emit("close-modal");
        },
        toggleList: function (showList) {
            this.showList = showList;
        },
        getFocus: function () {
            this.$nextTick().then(() => {
                let input = document.getElementById("postit-content");
                if (input) {
                    input.focus();
                }
            });
        },
        refreshCount: function () {
            if (this.$refs.noteListButton) {
                this.$refs.noteListButton.refreshCount();
            }
        },
    },
    watch: {
        showModal: function (val) {
            if (val) {
                this.showList = this.showListDefault;
                this.note.content = localStorage.getItem("postit-content");
                this.getFocus();
                this.refreshCount();
            }
        },
        showList: {
            immediate: true,
            handler: function (val) {
                if (!val) {
                    this.getFocus();
                }
                this.refreshCount();
            },
        },
    },
};
